<template>
  <div class="go-dashboard-preview">
    <iframe id="myframe" :src="iframeSrc" frameborder="0"></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      iframeSrc: ''
    }
  },
  methods: {
  },
  created() {
    this.iframeSrc = `${location.protocol}//go.cyberklick.com.cn/dashboard#/preview/${this.$route.params.id}`
  }
}
</script>
<style lang="less" scoped>
.go-dashboard-preview{
  height: 100%;
  iframe{
    width: 100%;
    height: calc(100vh - 5px);
  }
}
</style>